<!--
    描述：项目列表首页
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="w-filter-layout">
		<!-- 延迟顶部点击筛选栏 -->
		<div class="w-filter-header"
			 v-if="showFilter">
			<filterArea @doFilter="doSearch"
						ref="filterArea"
						:forSearch="true"></filterArea>
		</div>

		<!-- 内容区域 -->
		<div class="w-filter-content w-page-main">
			<div class="w-page-header">
				<searchArea v-model="filterRules.projectName"
							placeholderName="工程名称"
							:showFilter="true"
							:showMore="false"
							@on-search="doSearch"
							@on-refresh="doRefresh"
							@on-filter="showFilter = !showFilter"></searchArea>
				<div class="btnGroups">
					<el-button class="ml5"
							   title="批量删除项目"
							   size="small"
							   type="danger"
							   icon="el-icon-delete"
							   :class="{ opacityHide: !roleBtns.includes('batchDelete') }"
							   v-if="roleBtns.includes('batchDelete') "
							   @click="deleteProejct"></el-button>
					<el-button class="ml5"
							   size="small"
							   type="primary"
							   v-if="roleBtns.includes('project-add') "
							   @click="addProject">新增项目</el-button>
					<el-button class="ml5"
							   size="small"
							   type="primary"
							   v-if="roleBtns.includes('project-tag') "
							   @click="showTagsDialog('add')">添加标签</el-button>
					<el-button plain
							   type="primary"
							   class="ml5"
							   size="small"
							   icon="el-icon-download"
							   v-if="roleBtns.includes('export-excel') "
							   @click="exportList('excel')">导出Excel</el-button>
					<el-button type=""
							   class="ml5"
							   size="small"
							   icon="el-icon-upload"
							   v-if="roleBtns.includes('export-html') "
							   @click="exportList('html')">导出Html</el-button>
				</div>
			</div>
			<!-- 表格主体 -->
			<div class="w-page-container">
				<projectTable ref="projectTable"
							  :showFilter="showFilter"
							  @currentRow="currentRow"></projectTable>

			</div>
		</div>

		<!-- 添加标签 -->
		<AddLabelDialog :isShowDialog="tagsDialog.visible"
						:curRowId="curRowId"
						:curRowName="curRowName"
						@close-dialogStatus="close_dialog"
						:dialogData="dialogData"></AddLabelDialog>
	</div>
</template>

<script>
import projectTable from './components/projectTable'
import AddLabelDialog from '@/components/addTag/AddLabelDialog'
import { mapState } from 'vuex'
import { deteleProjects } from '@/api/modules/project_manage'
import { getItem, setItem, removeItem } from '@/utils/auth'
import { exportExcel } from '@/utils/tools'
import * as API from '@/api/modules/home'

export default {
	name: 'Project-list',
	components: {
		projectTable,
		AddLabelDialog,
	},
	data() {
		return {
			showFilter: true,
			searchObj: {
				pname: '',
			},
			filterRules: {
				projectName: '',
				beginDateList: [],
				projectOriginList: [],
				curArea: [],
				projectPattenList: [],
				tags: [],
			},
			curRowId: '', // 当前行数据的id
			curRowName: '', //当前行项目名称
			tagsDialog: {
				visible: false,
				width: '800px',
				title: '添加标签',
				type: '',
				module: 'tag',
			},
			dialogData: {},
			tagList: [],
		}
	},
	methods: {
		// 搜索查询
		doSearch(arr) {
			// 筛选时的赋值处理
			if (arr) {
				console.log(arr)
				// 日期、年份
				this.filterRules.beginDateList = [
					...arr[0].list.map((x) => x.value),
				]

				// 来源
				this.filterRules.projectOriginList = [
					...arr[1].list.map((x) => x.value),
				]

				// 地区
				this.filterRules.curArea = [...arr[2].list.map((x) => x.value)]

				// 类型
				this.filterRules.projectPattenList = [
					...arr[3].list.map((x) => x.value),
				]

				// 标签
				this.filterRules.tags = arr[4] ? arr[4].list : []
			}

			this.$refs.projectTable.queryParams = Object.assign(
				{},
				this.filterRules
			)
			this.$refs.projectTable.getlistData()
		},
		//导出列表
		exportList(type) {
			console.log(this.filterRules)
			let params = Object.assign({}, this.filterRules)
			params.type = type
			exportExcel('busProContract/getExportExcel', params, '项目列表')
		},
		// 点击刷新
		doRefresh() {
			// 重置筛选栏
			this.$refs.filterArea.filterColumns.forEach((x) => {
				x.checkAll = x.custom ? false : true
				x.list.filter((y) => (y.checked = false))
			})
			this.$refs.filterArea.tags = []

			// 重置变量
			this.filterRules.projectName = ''
			this.filterRules.beginDateList = []
			this.filterRules.projectOriginList = []
			this.filterRules.curArea = []
			this.filterRules.projectPattenList = []
			this.filterRules.tags = []

			this.$refs.projectTable.queryParams = Object.assign(
				{},
				this.filterRules
			)
			this.$refs.projectTable.getlistData()
		},

		// 开始项目分析
		doAnalysis(isAdd) {
			// 获取选中的项目数组
			let list = this.$refs.projectTable.analysisList
			if (list.length > 0) {
				let arr = []
				list.map((x) => {
					let obj = {
						projectName: x.projectName,
						projectId: x.id,
					}
					arr.push(obj)
				})

				// 存在localStorage 中
				setItem('projectList', JSON.stringify(arr))
				// 判断当前是否在 项目列表页面，若是，默认跳转 造价总览
				let _path =
					this.$route.path === '/project-list'
						? '/cost-overview'
						: this.$route.path

				this.$router.replace({
					path: '/redirect' + _path,
					query: {
						projectId: arr[0].projectId,
					},
				})
			} else {
				this.$message.info('请选择要分析的 项目！')
			}
		},

		// 新增项目
		addProject() {
			this.$router.push({
				path: '/project-add',
			})
		},

		//删除项目
		deleteProejct() {
			let delList = this.$refs.projectTable.deleteList

			if (delList.length > 0) {
				this.$confirm('确认要删除当前数据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						// 调用删除接口
						deteleProjects(delList)
							.then((res) => {
								this.doSearch()
								// 清空删除数组
								this.$refs.projectTable.deleteList = []

								// 判断是否有在分析的数据
								let projectList = JSON.parse(
									getItem('projectList')
								)
								if (projectList && projectList.length > 0) {
									delList.map((x) => {
										let _index = projectList.findIndex(
											(y) => y.projectId === x
										)

										if (_index > -1) {
											projectList.splice(_index, 1)
										}
									})

									if (projectList.length > 0) {
										setItem(
											'projectList',
											JSON.stringify(projectList)
										)
									} else {
										removeItem('projectList')
									}
								}
								this.$message.success('删除成功')
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				this.$message.warning('请选择要删除的项目！')
			}
		},

		/************ 添加标签 ************/
		// 行点击事件
		currentRow(row) {
			this.curRowId = row.id
		},

		// 展示标签弹窗
		showTagsDialog(type) {
			let checkList = this.$refs.projectTable.$refs.xTable.selection
			if (checkList.length == 0 && this.curRowId == '') {
				this.$message.warning('请先选择要添加标签的项目！')
				return
			}
			if (checkList.length > 1) {
				this.$message.warning('不能同时对多条数据进行添加标签操作！')
				return
			}
			if (checkList.length == 1) {
				this.curRowId = checkList[0].id
			}

			switch (type) {
				case 'add':
					// 新增
					let params = {
						objectId: this.curRowId,
						applys: '1056001',
						createUserid: this.userInfo.id,
					}

					API.getObjectTags(params).then((res) => {
						let { privateExsitTags, platTags, privateTags } =
							res.data
						this.originalTags = this.$utils.clone(
							privateExsitTags,
							true
						)
						// 已选择标签
						this.selectedTags = privateExsitTags

						// 所有标签集合
						this.allTags = [...platTags, ...privateTags]
						this.dialogData = {
							originalTags: this.originalTags,
							selectedTags: this.selectedTags,
							allTags: this.allTags,
						}
					})
					break
				case 'view':
					break
			}
			this.tagsDialog.visible = true
			this.tagsDialog.type = type
		},

		close_dialog(val) {
			this.tagsDialog.visible = false
			this.curRowId = ''
			if (!val) {
				this.$refs.projectTable.getlistData()
				this.$refs.filterArea.getAllTags()
			}
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
}
</script>

<style scoped lang="less">
</style>
